import React, { useState } from 'react'
import { Button } from 'antd'
import gql from 'graphql-tag'
import { useFormContext } from '@/state/main-form/reducer'
import style from './button.module.sass'

type Props = {
	setChatOpen: (chatOpen: boolean) => void
}

export const LlmButton = ({ setChatOpen }: Props) => {
	const formContext = useFormContext()

	if (!(formContext.form.__typename === 'FormType' && formContext.form.llmInterface?.id)) {
		return null
	}

	return (
		<Button onClick={() => setChatOpen(true)} className={style.aiSupportButton} type="primary" size="middle">
			AI Support
		</Button>
	)
}
